import React, { useEffect } from "react";
import { Link } from "react-router-dom";

export const VideoModal = ({ src, poster, onClose }) => {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-[70] flex items-center justify-center bg-[#111827]/85 p-4 backdrop-blur-sm"
      onClick={onClose}
      data-testid="video-modal"
    >
      <button
        onClick={onClose}
        className="absolute right-5 top-5 flex h-11 w-11 items-center justify-center rounded-full bg-white/10 text-2xl leading-none text-white transition-colors hover:bg-white/20"
        aria-label="Luk"
        data-testid="video-modal-close"
      >
        ×
      </button>
      <div className="flex w-full max-w-[420px] flex-col items-center gap-4" onClick={(e) => e.stopPropagation()}>
        <div className="w-full overflow-hidden rounded-3xl bg-black preview-shadow-lift">
          <video
            controls
            autoPlay
            playsInline
            poster={poster}
            className="aspect-[9/16] h-auto max-h-[78vh] w-full object-contain"
            data-testid="video-modal-player"
          >
            <source src={src} type="video/mp4" />
          </video>
        </div>
        <Link
          to="/perspektiver"
          onClick={onClose}
          className="text-[15px] font-semibold text-white/85 transition-colors hover:text-white"
          data-testid="video-modal-more"
        >
          Se flere perspektiver →
        </Link>
      </div>
    </div>
  );
};

export default VideoModal;
